import {AssemblyScreen} from "./AssemblyScreen";
import {TiledSprite} from "../GameObjects/TiledSprite";
import {MonsterModel, MonsterSlot} from "../GameObjects/Assembly/MonsterModel";
import {Ease} from "../Core/Animatable";
import {Callback, Dict} from "../Core/Reflection";
import {AudioChannel} from "../Core/AudioChannel";
import {stopVO} from "../Data/VoiceOver";

export class MonsterScreen extends AssemblyScreen<MonsterSlot> {

    public readonly waterBack = this.main.addChild(new TiledSprite());
    public readonly waterFront = this.main.addChild(new TiledSprite());

    init(pSize: PIXI.Point, model: MonsterModel) {
        super.init(pSize, model);

        this.buttons.forEach(it => it.clickSfx = "item-change");

        this.waterBack.zIndex = this.background.zIndex + 1;
        this.waterFront.zIndex = this.assembly.zIndex + 1;

        this.initWaterAnimation(this.waterBack, -0.2, -0.05, 1, 0);
        this.initWaterAnimation(this.waterFront, 0.3, 0.08, 1, 0.4);
    }

    protected getStartVO(): (string | number)[] | undefined {
        return ["LetsGoLuna_083"];
    }

    protected getSlotHoverVO(): Dict<MonsterSlot, string> | undefined {
        return {
            [MonsterSlot.Body]: "LetsGoLuna_073",
            [MonsterSlot.Head]: "LetsGoLuna_071",
            [MonsterSlot.FrontLegs]: "LetsGoLuna_072",
            [MonsterSlot.BackLegs]: "LetsGoLuna_082",
        };
    }

    protected getAssemblyCompleteVO(): string[] | undefined {
        return [
            "LetsGoLuna_084",
            "LetsGoLuna_085",
            "LetsGoLuna_086",
            "LetsGoLuna_087"
        ];
    }

    protected getFactVO(): string[] | undefined {
        return [
            "LetsGoLuna_088",
            "LetsGoLuna_089"
        ];
    }

    private initWaterAnimation(water: TiledSprite, offsetX: number, offsetY: number, time: number, delay: number) {
        offsetX = water.x + water.tiles[0].width * offsetX;
        offsetY = water.y + water.tiles[0].height * offsetY;
        water.tweenTo(time, Ease.sineInOut, {
            motionPath: {path: [{x: (water.x + offsetX) * 0.5, y: offsetY}, {x: offsetX, y: water.y}]},
            repeat: -1,
            yoyo: true,
            delay: delay
        });
    }

    private moveWaterUp(water: TiledSprite, cb?: Callback) {
        for (const tile of water.tiles) {
            tile.moveYTo(tile.y - tile.height * 0.4, 0.6, Ease.sineInOut, cb);
        }
    }

    private moveMonster(cb?: Callback) {
        this.assembly.moveYTo(this.waterFront.y - this.waterFront.height * 0.3, 1, Ease.backInOut.config(10), cb);
        AudioChannel.SFX.play("seamonster-water");
    }

    protected returnHome(model: MonsterModel, submitted: boolean) {
        if (submitted) {
            this.buttonOk.enabled = false;
            this.buttonOk.stopPulse();
            this.hideButtons([...this.buttons, this.buttonOk], () => {
                this.moveWaterUp(this.waterBack);
                this.moveWaterUp(this.waterFront);
                this.moveMonster(() => this.assembly.delayedCall(3, () => this.superReturnHome(model, submitted)));
            });
            this.clearKeyboard();
            this._factsDisabled = true;
            stopVO();
            this.playCompleteVO();
        } else {
            this.superReturnHome(model, submitted);
        }
    }

    private superReturnHome(model: MonsterModel, submitted: boolean) {
        super.returnHome(model, submitted);
    }
}